import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 直接导入翻译文件
const zhTranslation = {
  "company": {
    "name": "合润化工",
    "slogan": "专业的化工产品供应商，为您提供高品质的抗氧化解决方案"
  },
  "nav": {
    "products": "产品",
    "about": "关于我们",
    "contact": "联系方式"
  },
  "about": {
    "description": "合润化工是一家专业从事抗氧化剂研发、生产和销售的高新技术企业。我们致力于为客户提供高品质的抗氧化解决方案，产品广泛应用于塑料、橡胶、涂料等领域。公司拥有先进的生产设备和专业的技术团队，可以为客户提供全方位的技术支持和服务。"
  },
  "contact": {
    "email": {
      "label": "欢迎通过以下邮箱联系我们："
    }
  },
  "product": {
    "category": "类别",
    "specifications": "规格",
    "applications": "应用领域",
    "safetyInfo": "安全信息",
    "warnings": "警告",
    "handling": "操作指南"
  },
  "products": {
    "p001": {
      "name": "抗氧剂 DLTDP",
      "description": "与酚类抗氧剂混合使用，增强聚丙烯和高密度聚乙烯的老化稳定性和光稳定性",
      "applications": {
        "1": "聚烯烃",
        "2": "高冲击聚苯乙烯",
        "3": "ABS树脂"
      }
    },
    "p002": {
      "name": "抗氧剂 CPL",
      "description": "适用于天然橡胶、合成橡胶聚合体及丁二烯化合物，具有良好的抗氧效果和分散性",
      "applications": {
        "1": "天然橡胶",
        "2": "合成橡胶",
        "3": "丁二烯化合物"
      }
    },
    "p003": {
      "name": "AO系列乳液抗氧剂",
      "description": "推荐用于丁二烯类胶乳中，提供高效稳定性和抗氧性",
      "applications": {
        "1": "丁二烯胶乳",
        "2": "水性涂料",
        "3": "乳液产品"
      }
    },
    "p004": {
      "name": "抗氧剂 618",
      "description": "新型磷酯类辅助高温抗氧剂，与受阻酚类抗氧剂复配使用",
      "applications": {
        "1": "塑料制品",
        "2": "橡胶材料",
        "3": "高温加工"
      }
    },
    "p005": {
      "name": "抗氧剂 DSTDP",
      "description": "优质硫酯类辅助抗氧剂，效果优于DLTDP，适用于各类有机化合物",
      "applications": {
        "1": "有机化合物",
        "2": "塑料制品",
        "3": "橡胶制品"
      }
    },
    "p006": {
      "name": "水性涂料乳液抗氧剂",
      "description": "替代传统抗氧剂，广泛应用于水性涂料和涂层行业",
      "applications": {
        "1": "水性涂料",
        "2": "涂层",
        "3": "乳液产品"
      }
    },
    "p007": {
      "name": "抗氧剂 DTDTP",
      "description": "液体辅助抗氧剂，与树脂相容性好，适用于聚烯烃、ABS和PVC",
      "applications": {
        "1": "聚烯烃",
        "2": "ABS",
        "3": "PVC"
      }
    },
    "p008": {
      "name": "乳液抗氧剂 245",
      "description": "高性能受阻酚类抗氧剂，主要用于防止热氧化降解",
      "applications": {
        "1": "有机聚合物",
        "2": "热塑性材料",
        "3": "工程塑料"
      }
    },
    "p009": {
      "name": "抗氧剂 GM",
      "description": "有效防止聚合物热老化，适用于各类热塑性塑料和弹性体",
      "applications": {
        "1": "热塑性塑料",
        "2": "弹性体",
        "3": "工程材料"
      }
    }
  },
  "footer": {
    "poweredBy": "技术支持：",
    "version": "版本"
  }
};

const enTranslation = {
  "company": {
    "name": "HeRun Chemical",
    "slogan": "Professional chemical product supplier, providing high-quality antioxidant solutions"
  },
  "nav": {
    "products": "Products",
    "about": "About",
    "contact": "Contact"
  },
  "about": {
    "description": "HeRun Chemical is a high-tech enterprise specializing in the research and development, production, and sales of antioxidants. We are committed to providing high-quality antioxidant solutions for customers, with products widely used in plastics, rubber, coatings, and other fields. The company has advanced production equipment and a professional technical team to provide comprehensive technical support and services for customers."
  },
  "contact": {
    "email": {
      "label": "Please contact us via email:"
    }
  },
  "product": {
    "category": "Category",
    "specifications": "Specifications",
    "applications": "Applications",
    "safetyInfo": "Safety Information",
    "warnings": "Warnings",
    "handling": "Handling"
  },
  "products": {
    "p001": {
      "name": "Antioxidant DLTDP",
      "description": "Used in combination with phenolic antioxidants to enhance aging stability and light stability of polypropylene and high-density polyethylene",
      "applications": {
        "1": "Polyolefins",
        "2": "High Impact Polystyrene",
        "3": "ABS Resin"
      }
    },
    "p002": {
      "name": "Antioxidant CPL",
      "description": "Suitable for natural rubber, synthetic rubber polymers and butadiene compounds, providing excellent antioxidant effect and dispersibility",
      "applications": {
        "1": "Natural Rubber",
        "2": "Synthetic Rubber",
        "3": "Butadiene Compounds"
      }
    },
    "p003": {
      "name": "AO Series Emulsion Antioxidant",
      "description": "Recommended for butadiene latex, providing high efficiency stability and antioxidant properties",
      "applications": {
        "1": "Butadiene Latex",
        "2": "Water-based Coatings",
        "3": "Emulsion Products"
      }
    },
    "p004": {
      "name": "Antioxidant 618",
      "description": "New phosphite auxiliary high-temperature antioxidant, used in combination with hindered phenolic antioxidants",
      "applications": {
        "1": "Plastic Products",
        "2": "Rubber Materials",
        "3": "High Temperature Processing"
      }
    },
    "p005": {
      "name": "Antioxidant DSTDP",
      "description": "Excellent thioester auxiliary antioxidant, more effective than DLTDP, suitable for various organic compounds",
      "applications": {
        "1": "Organic Compounds",
        "2": "Plastic Products",
        "3": "Rubber Products"
      }
    },
    "p006": {
      "name": "Water-based Paint Emulsion Antioxidant",
      "description": "Alternative to traditional antioxidants, widely used in water-based paints and coatings industries",
      "applications": {
        "1": "Water-based Paints",
        "2": "Coatings",
        "3": "Emulsion Products"
      }
    },
    "p007": {
      "name": "Antioxidant DTDTP",
      "description": "Liquid auxiliary antioxidant with good resin compatibility, suitable for polyolefins, ABS and PVC",
      "applications": {
        "1": "Polyolefins",
        "2": "ABS",
        "3": "PVC"
      }
    },
    "p008": {
      "name": "Emulsion Antioxidant 245",
      "description": "High-performance hindered phenolic antioxidant, mainly used to prevent thermal oxidative degradation",
      "applications": {
        "1": "Organic Polymers",
        "2": "Thermoplastic Materials",
        "3": "Engineering Plastics"
      }
    },
    "p009": {
      "name": "Antioxidant GM",
      "description": "Effectively prevents thermal aging of polymers, suitable for various thermoplastics and elastomers",
      "applications": {
        "1": "Thermoplastics",
        "2": "Elastomers",
        "3": "Engineering Materials"
      }
    }
  },
  "footer": {
    "poweredBy": "Powered by",
    "version": "Version"
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      zh: {
        translation: zhTranslation
      },
      en: {
        translation: enTranslation
      }
    },
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
      cookieMinutes: 48 * 60
    },
    returnNull: false,
    fallbackNS: 'translation',
    supportedLngs: ['zh', 'en']
  } as const);

export default i18n; 